import { render, staticRenderFns } from "./SsalesoderView.vue?vue&type=template&id=61f5fb00&scoped=true"
import script from "./SsalesoderView.vue?vue&type=script&lang=js"
export * from "./SsalesoderView.vue?vue&type=script&lang=js"
import style0 from "./SsalesoderView.vue?vue&type=style&index=0&id=61f5fb00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f5fb00",
  null
  
)

export default component.exports